module.exports = __webpack_public_path__ + "img/chooseProject.c656556e.png";